import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarTaxi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCarTaxi"><Path d="M2.5 19.4998V10.4998L6.5 4.49979H17.5L21.5 10.4998V19.4998H17.5V17.4998H6.5V19.4998H2.5Z" stroke="currentColor"/><Path d="M1 10.5H2.5" stroke="currentColor"/><Path d="M21.5 10.5H23" stroke="currentColor"/><Path d="M5 13.5H8" stroke="currentColor"/><Path d="M16 13.5H19" stroke="currentColor"/><Path d="M9.5 2.5V4.5H14.5V2.5H9.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCarTaxi;
